import React from 'react';
import MarkdownDocPage from '../MarkdownDocPage';

export default function UserManualDataPrincipalsPage() {
    return <MarkdownDocPage title="Data Principals" markdownUrl="/docs/user-manual/pages/data-principals.md" />;
}

